import { RiShoppingBasket2Line, RiArrowLeftLine } from "@remixicon/react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Buttons.module.scss";
import { useEffect } from "react";
import { useAppContext } from "@context/appContext";

interface ButtonProps {
  isCartEmpty: boolean;
  totalItems: number;
}

const Button = ({ isCartEmpty, totalItems }: ButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCartPage = location.pathname === "/cart";
  const { setShowPaymentModal, totalPrice } = useAppContext();

  useEffect(() => {
    if (isCartEmpty && isCartPage) {
      navigate("/");
    }
  }, [isCartEmpty, isCartPage, navigate]);

  const handleToggle = () => {
    if (isCartPage) {
      navigate("/");
    } else {
      navigate("/cart");
    }
  };

  return (
    <div className={styles.cartButtons}>
      <button
        className={`${styles.toggle} ${
          isCartEmpty ? styles["toggle--disabled"] : ""
        }`}
        type="button"
        disabled={isCartEmpty}
      >
        {isCartPage ? (
          <RiArrowLeftLine onClick={!isCartEmpty ? handleToggle : undefined} />
        ) : (
          <RiShoppingBasket2Line
            onClick={!isCartEmpty ? handleToggle : undefined}
          />
        )}
      </button>
      <button
        className={`${styles.cartInfo} ${
          isCartEmpty ? styles["cartInfo--disabled"] : ""
        }`}
        type="button"
        disabled={isCartEmpty}
        onClick={() => {
          setShowPaymentModal(true);
        }}
      >
        <div className={styles.count}>
          <span className={styles.countNumber}>{totalItems}</span>
        </div>
        <div className={styles.total}>
          <span className={styles.totalText}>Pay €{totalPrice}</span>
        </div>
      </button>
    </div>
  );
};

export default Button;
